<template>
  <div class="view-box">
    <!-- banner -->
    <div class="banner">
      <el-carousel>
        <el-carousel-item v-for="i in imgsList" :key="i.id">
          <img :src="i.homePage" alt="" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 系统 -->
    <div class="case-study-area">
      <div class="container">
        <div class="title">
          <div>在线平台</div>
          <p>信息学是理科五大学科竞赛之一，信息学的认可度和含金量极高。</p>
        </div>
        <div class="row">
          <div class="col-lg-3 col-md-6" v-for="i in platformList" :key="i.id">
            <div class="single-case-study-inner">
              <div class="icon">
                <img src="../assets/24.png" alt="img" />
              </div>
              <div class="details">
                <p style="font-size: 24px">{{ i.name }}</p>
                <p>在线系统</p>
                <div v-if="!token || token === ''" class="read-more-text">
                  进入系统 <i class="iconfont icon-direction-right"></i>
                </div>
                <div v-else class="read-more-text shub" @click="toOtherPage(i)">
                  进入系统 <i class="iconfont icon-direction-right"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 文章 -->
    <div class="container">
      <div class="title">
        <div>赛事新闻</div>
        <p>随时随地，一起关注学校热点。</p>
      </div>
      <el-row class="" :gutter="20" style="margin-bottom: 10px">
        <el-col :xs="24" :sm="12" :md="8"
          ><div class="text1">
            <div class="t-name1">
              学校热点
              <router-link
                :to="{
                  path: '/articleList',
                  query: { noticeType: '1' }
                }"
                ><div class="t-more">More+</div></router-link
              >
            </div>
            <img v-if="pic1" class="t-img" :src="pic1" alt="" />
            <ul class="align">
              <li class="align-items" v-for="i in indexList1" :key="i.id">
                <router-link
                  :to="{
                    path: '/articleDetail',
                    query: { id: i.noticeId }
                  }"
                >
                  {{ i.noticeTitle }}
                </router-link>
              </li>
            </ul>
          </div></el-col
        >
        <el-col :xs="24" :sm="12" :md="8"
          ><div class="text2">
            <div class="t-name2">
              国赛奖牌榜
              <router-link
                :to="{
                  path: '/articleList',
                  query: { noticeType: '2' }
                }"
                ><div class="t-more">More+</div></router-link
              >
            </div>
            <img v-if="pic2" class="t-img" :src="pic2" alt="" />
            <ul class="align">
              <li class="align-items" v-for="i in indexList2" :key="i.id">
                <router-link
                  :to="{
                    path: '/articleDetail',
                    query: { id: i.noticeId }
                  }"
                >
                  {{ i.noticeTitle }}
                </router-link>
              </li>
            </ul>
          </div></el-col
        >
        <el-col :xs="24" :sm="12" :md="8"
          ><div class="text3">
            <div class="t-name3">
              风云人物
              <router-link
                :to="{
                  path: '/peopleList',
                  query: { noticeType: '3' }
                }"
                ><div class="t-more">More+</div></router-link
              >
            </div>
            <ul class="align">
              <li class="align-items" v-for="i in indexList3" :key="i.id">
                <router-link
                  style="display: flex; justify-content: space-between"
                  :to="{
                    path: '/articleDetail',
                    query: { id: i.noticeId }
                  }"
                >
                  <span>{{ i.noticeTitle }}</span
                  ><span>{{ i.createTime }}</span>
                </router-link>
              </li>
            </ul>
          </div></el-col
        >
      </el-row>
    </div>
    <!-- 修改密码 -->
    <el-dialog
      title="修改密码"
      :visible.sync="open"
      width="600px"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <el-form ref="form1" :model="form1" :rules="rules1" label-width="90px">
        <el-form-item label="原密码">
          <el-input
            v-model="form1.old"
            placeholder="请输入原密码"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码">
          <el-input
            v-model="form1.new"
            placeholder="请输入新密码"
            show-password
            @input="inputMethod"
          ></el-input>
          <div style="color: #aaaaaa">
            *密码长度8位以上，必须由大写字母、小写字母、数字、特殊符号组成。
            <div v-show="form1.new.length !== 0" style="color: red">
              {{ note }}
            </div>
          </div>
        </el-form-item>
        <el-form-item label="确认新密码">
          <el-input
            v-model="form1.new2"
            placeholder="请确认新密码"
            show-password
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getInfo,
  articleList,
  imgsList,
  listPlatform,
  resetPwd
} from '@/api/index.js'
import { mapGetters, mapMutations, mapState } from 'vuex'
import { decrypt } from '@/utils/jsencrypt'
import Cookies from 'js-cookie'

export default {
  name: 'mains',
  data() {
    return {
      indexList1: [],
      indexList2: [],
      indexList3: [],
      pic1: '',
      pic2: '',
      pic3: '',
      imgsList: [],
      platformList: [],
      //修改密码
      open: false,
      userId: null,
      // password: '',
      note: '',
      form1: {
        old: '',
        new: '',
        new2: ''
      },
      rules1: {
        old: [{ required: true, trigger: 'blur', message: '请输入原密码' }],
        new: [{ required: true, trigger: 'blur', message: '请输入新密码' }],
        new2: [{ required: true, trigger: 'blur', message: '请确认新密码' }]
      }
    }
  },
  computed: {
    ...mapState(['token', 'password'])
  },
  mounted() {
    //请求用户信息
    getInfo().then(({ data }) => {
      console.log(data)
      console.log(this.token)
      if (data.code === 401) {
        Cookies.remove('token')
        return
      }
      this.userId = data.user.userId
      if (data.code === 200 && data.isResetPwd) {
        this.open = true
      }
    })
    this.getImgList()
    this.getPlatformList()
    this.getArticleList1()
    this.getArticleList2()
    this.getArticleList3()
  },
  methods: {
    //保存kv再跳转
    toOtherPage(i) {
      console.log(i)
      if (i.name === '初中部OJ') {
        sessionStorage.setItem('key', 'value')
        console.log(1111)
      }
      let res = sessionStorage.getItem('key')
      console.log(res)
      window.location.href = i.link
    },
    //banner
    async getImgList() {
      let { data } = await imgsList()
      if (data.code === 200) {
        this.imgsList = data.rows
      }
    },
    //在线系统
    async getPlatformList() {
      let { data } = await listPlatform()
      if (data.code === 200) {
        let linsP = data.rows
        this.platformList = linsP.filter((i) => {
          return i.status === '1'
        })
      }
    },
    async getArticleList1() {
      let { data } = await articleList({ noticeType: '1' })
      if (data.code === 200) {
        //8条
        this.indexList1 = data.rows.slice(0, 7)
        this.pic1 = this.indexList1[0].coverUrl
          ? this.indexList1[0].coverUrl
          : null
        this.pic1 = this.pic1.replace(/10\.16\.2\.20:8089/g, '218.5.5.242:8089')
      }
    },
    async getArticleList2() {
      let { data } = await articleList({ noticeType: '2' })
      if (data.code === 200) {
        this.indexList2 = data.rows.slice(0, 7)
        this.pic2 = this.indexList2[0].coverUrl
          ? this.indexList2[0].coverUrl
          : null
        this.pic2 = this.pic2.replace(/10\.16\.2\.20:8089/g, '218.5.5.242:8089')
      }
    },
    async getArticleList3() {
      let { data } = await articleList({ noticeType: '3' })
      if (data.code === 200) {
        this.indexList3 = data.rows.slice(0, 7)
        this.pic3 = this.indexList3[0].coverUrl
          ? this.indexList3[0].coverUrl
          : null
        this.pic3 = this.pic3.replace(/10\.16\.2\.20:8089/g, '218.5.5.242:8089')
      }
    },
    inputMethod(value) {
      var strongRegex = new RegExp(
        '^(?=.{8,})(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*\\W).*$',
        'g'
      )
      if (strongRegex.test(value)) {
        this.note = '密码输入符合规则'
      } else {
        this.note = '密码输入不符合规则，请检查'
      }
    },
    submitForm() {
      this.$refs['form1'].validate((valid) => {
        if (valid) {
          // if (this.form1.old !== this.password) {
          // if (this.form1.old !== decrypt(Cookies.get('password'))) {
          if (this.form1.old !== decrypt(this.password)) {
            this.$message.error('原密码输入错误')
          } else if (this.form1.new !== this.form1.new2) {
            this.$message.error('两次新密码输入不一致')
          } else if (this.note !== '密码输入符合规则') {
            this.$message.error('密码输入不符合校验规则')
          } else {
            //修改密码
            resetPwd({ password: this.form1.new, userId: this.userId }).then(
              ({ data }) => {
                if (data.code === 200) {
                  this.$message({
                    message: '密码修改成功',
                    type: 'success'
                  })
                  this.$router.push({ path: '/login' })
                }
              }
            )
          }
        }
      })
    },
    cancel() {
      this.open = false
      this.form1 = {
        old: '',
        new: '',
        new2: ''
      }
    }
  }
}
</script>

<style lang="less" scoped>
.view-box {
  background-color: #fff;
}
// banner
.banner {
  width: 100%;
  height: 450px;
  img {
    width: 100%;
    height: 100%;
  }
}
//系统

.title {
  div {
    padding-top: 35px;
    font-size: 40px;
    line-height: 40px;
    background: url('../assets/title-bg.png') no-repeat;
    background-size: auto 100%;
  }
  p {
    padding-top: 5px;
    color: #7a7a7a;
  }
}
[class^='text'] {
  width: 100%;
  [class^='t-name'] {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 38px;
    font-size: 18px;
    color: #fff;
    padding: 0 10px;
    align-items: center;
    .t-more {
      cursor: pointer;
      color: #fff;
    }
  }
  .t-name1 {
    background-color: #61bd89;
  }
  .t-name2 {
    background-color: #8b8b8b;
  }
  .t-name3 {
    background-color: #27ae61;
  }
  .t-name4 {
    background-color: #5c615e;
  }
  .t-img {
    width: 100%;
    height: 140px;
  }
  .align {
    margin: 5px 0;
    padding: 0;
  }
  .align-items {
    list-style: none;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding: 3px;
    font-size: 16px;
    color: #747373;
  }
}
// .read-more-text i {
//   top: -2px;
// }
// //
// .post-content,
// .post-title {
//   overflow: hidden !important;
//   text-overflow: ellipsis !important; /* 超出部分省略号 */
//   word-break: break-all !important; /* break-all(允许在单词内换行。) */
//   display: -webkit-box !important; /* 对象作为伸缩盒子模型显示 */
//   -webkit-box-orient: vertical !important; /* 设置或检索伸缩盒对象的子元素的排列方式 */
//   -webkit-line-clamp: 2 !important; /* 显示的行数 */
// }
// ::v-deep .post-content {
//   font-size: 16px;
//   line-height: 1.6;
//   font-weight: 400;
//   color: rgb(110, 110, 110);
//   -webkit-line-clamp: 3 !important; /* 显示的行数 */
//   p {
//     margin: 0;
//   }
// }
// .more {
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   border-bottom: 2px solid #cc1a1a;
// }

// .align-items a:hover {
//   color: #cc1a1a;
// }
// h4 {
//   font-weight: 500;
// }
// .blog-thumbnail {
//   img {
//     height: 200px;
//     margin-top: 10px;
//   }
// }
::v-deep.el-carousel {
  height: 100%;
  .el-carousel__container {
    height: 100% !important;
  }
}
.shub {
  cursor: pointer;
}
.tab-pane:hover {
  cursor: pointer;
}
</style>
